import classnames from 'classnames'
import omit from 'lodash-es/omit'

import * as styles from './MultiValuedListItem.module.css'

function MultiValuedListItem({
  className = styles.MultiValuedListItem,
  isSingle,
  size,
  unread,
  variant,
  ...props
}) {
  const divProps = omit(props, ['activeItem'])

  const mods = {
    [styles.single]: isSingle,
    [styles.unread]: unread,
    ...(size ? { [styles[size]]: true } : null),
    ...(variant ? { [styles[variant]]: true } : null),
  }

  return <div {...divProps} className={classnames(className, mods)} />
}

export default MultiValuedListItem
